import { createFileRoute } from '@tanstack/react-router';
import { SInviteAccept } from '@/screens/SInviteAccept/SInviteAccept';

export const Route = createFileRoute('/invite')({
  component: SInviteAccept,
  validateSearch: (raw: Record<string, unknown>): { token?: string } => ({
    token: typeof raw.token === 'string' ? raw.token : undefined,
  }),
  // Render outside the normal AppShell — no AppHeader / banner — so
  // the invitee isn't asked to sign in to view the invitation. The
  // route opts out via the same `shell: 'none'` flag the /auth route
  // uses.
  staticData: { shell: 'none' as const },
});
